import React from "react";

const NotFoundPage = () => <p>The page was not found.</p>;
export default NotFoundPage;
